import React from "react";
import "./../styles/global.scss";
import Navbar from "./../components/Navbar";
import IndexPage from "./index";
import AboutPage from "./about";
import ContactPage from "./contact";
import LegalPage from "./legal";
import DeveloperPage from "./developer";
import AppsPage from "./apps";
import AccountableAiPage from "./accountable-ai";
import { Switch, Route, Router } from "./../util/router";
import NotFoundPage from "./404";
import Footer from "./../components/Footer";
import HelpdeskPage from "./helpdesk";
import FaucetPage from "./faucet";

function App(props) {
  return (
    <Router>
      <>
        <Navbar
          color="white"
          spaced={true}
          logo="pds_logo.svg"
        />
        <Switch>
          <Route exact path="/" component={IndexPage} />

          <Route exact path="/about" component={AboutPage} />

          <Route exact path="/contact" component={ContactPage} />

          <Route exact path="/legal/:section" component={LegalPage} />

          <Route exact path="/developer" component={DeveloperPage} />

          <Route exact path="/apps" component={AppsPage} />

          <Route exact path="/accountable-ai" component={AccountableAiPage} />

          <Route exact path="/helpdesk" component={HelpdeskPage} />

          <Route exact path="/faucet" component={FaucetPage} />
          
          <Route path="/callback" component={IndexPage} />

          <Route component={NotFoundPage} />

        </Switch>

        <Footer
          color="light"
          size="normal"
          backgroundImage=""
          backgroundImageOpacity={1}
          copyright={`© ${new Date().getFullYear()} Personal Digital Spaces LLC`}
          logo="pds_logo_reg.svg"
        />
      </>
    </Router>
  );
}

export default App;
